import { ERecurringTaskEndType } from '../../../../../../../types/rest/recurringTask/IRestRecurringTask';

export const END_TYPES = [ERecurringTaskEndType.NEVER, ERecurringTaskEndType.DATE, ERecurringTaskEndType.REPEATS];
